import { render, staticRenderFns } from "./NsDonationForm.vue?vue&type=template&id=497ccb0e&scoped=true&"
import script from "./NsDonationForm.vue?vue&type=script&lang=js&"
export * from "./NsDonationForm.vue?vue&type=script&lang=js&"
import style0 from "./NsDonationForm.vue?vue&type=style&index=0&lang=scss&module=true&"
import style1 from "./NsDonationForm.vue?vue&type=style&index=1&id=497ccb0e&lang=scss&scoped=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "497ccb0e",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/gitlab-runner-data/builds/ns-am/product/apps/catalog/components/Button.vue').default})
